import AppsIcon from '@material-ui/icons/Apps';
import {
  createFrontendModule,
  createRouteRef,
  NavItemBlueprint,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import React from 'react';

const catalogRouteRef = createRouteRef();
const catalogItemRouteRef = createRouteRef({ params: ['id'] });

const catalogPage = PageBlueprint.make({
  name: 'catalog',
  params: {
    path: '/catalog',
    routeRef: catalogRouteRef,
    loader: () =>
      import('./CatalogPage').then(m => React.createElement(m.CatalogPage)),
  },
});

const catalogItemPage = PageBlueprint.make({
  name: 'catalog-item',
  params: {
    path: '/catalog/:id',
    routeRef: catalogItemRouteRef,
    loader: () =>
      import('./CatalogItemPage').then(m =>
        React.createElement(m.CatalogItemPage),
      ),
  },
});

const catalogNavItem = NavItemBlueprint.make({
  name: 'catalog',
  params: {
    routeRef: catalogRouteRef,
    title: 'Catalog',
    icon: AppsIcon,
  },
});

export const catalogModule = createFrontendModule({
  pluginId: 'app',
  extensions: [catalogPage, catalogItemPage, catalogNavItem],
});
